// src/pages/CompanyPage.tsx
import React, { useState } from 'react';
import CompanyModal from './Company';
import BasicCli from '../../main/components/basicCli/BasicCli';

const CompanyPage: React.FC = () => {
  const [showModal, setShowModal] = useState(true);

  return (
    <BasicCli>
      <CompanyModal show={showModal} onClose={() => setShowModal(false)} />
    </BasicCli>
  );
};

export default CompanyPage;
